import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { type ActionItem } from "@tokenterminal/ui/ActionButton"
import { isLinkItem } from "@tokenterminal/ui/ActionButton/ActionButton.v4"
import { Row, type RowProps } from "@tokenterminal/ui/Row"
import Link from "next/link"
import { type ElementType } from "react"
import { twMerge } from "tailwind-merge"

const itemClassName = twMerge(
  "w-full p-2.5 rounded-md relative cursor-pointer gap-2 text-sm outline-none",
  'focus:bg-bg-surface-hover hover:bg-bg-surface-hover [&[data-selected="true"]]:bg-bg-surface-hover [&[data-focused="true"]]:bg-bg-surface-hover'
)

const ActionItem = ({
  item,
  closeMenu,
  className,
}: {
  item: ActionItem & {
    icon?: ElementType
  } & Omit<RowProps, "label" | "start">
  closeMenu?: () => void
  className?: string
}) => {
  const { label, onClick, icon, ...itemProps } = item

  const iconComponent = icon ? <Icon as={icon} width={16} /> : null

  return (
    <li
      role="option"
      className={twMerge("flex gap-2", className)}
      onClick={(e: any) => {
        // @ts-ignore
        onClick?.(e)
        if (closeMenu) {
          closeMenu()
        }
      }}
    >
      {isLinkItem(itemProps) ? (
        // @ts-ignore
        <Row as={Link} {...itemProps} className={itemClassName}>
          {label}
          {iconComponent}
        </Row>
      ) : (
        <Row as="button" {...itemProps} className={itemClassName}>
          {label}
          {iconComponent}
        </Row>
      )}
    </li>
  )
}

export default ActionItem
